import rem from 'polished/lib/helpers/rem';
import { makeStyles } from 'tss-react/mui';

export default makeStyles()(({ palette }) => ({
  gradientBanner: {
    position: 'relative',
    padding: `${rem(8)} ${rem(12)}`,
    background:
      'linear-gradient(90deg, #2563EB 0%, #38BDF8 34.9%, #50C686 68.23%, #6366F1 100%)',
    borderRadius: rem(8),
    boxShadow: '0px 3px 8px rgba(14, 165, 233, 0.12)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  typo: {
    textAlign: 'center',
    color: palette.common.white,
  },
  closeIcon: {
    position: 'absolute',
    right: rem(12),
    color: palette.common.white,
  },
}));
